import React from "react";
import IntlMessages from "util/IntlMessages";

const MenuList = {
  client: [
    {
      title: "Dashboard",
      url: "/client/dashboard",
      icon: "dasbhoard",
      permissionKey: "customerDashboard",
      top: "4px",
      keyTitle: "customerDashbaord",
      dependOnPlane: false,
    },
    {
      title: <IntlMessages id="leftMenu.client.carePlan" />,
      url: "/client/carePlan",
      icon: "auth-screen",
      permissionKey: "customerDashboard",
      top: "4px",
      keyTitle: "customedsdrDashbaord",
      dependOnPlane: false,
    },
    {
      title: <IntlMessages id="leftMenu.client.dailyUpdate" />,
      url: "/client/dailyUpdate",
      icon: "feedback",
      permissionKey: "customerDashboard",
      top: "4px",
      dependOnPlane: true,
    },
    {
      title: <IntlMessages id="leftMenu.client.reports" />,
      url: "/reports",
      icon: "product-list",
      permissionKey: "customerDashboard",
      top: "4px",
      dependOnPlane: true,
    },
    {
      title: <IntlMessages id="leftMenu.client.patientBaseline" />,
      url: "/client/patientBaseline",
      icon: "modal",
      permissionKey: "customerDashboard",
      top: "4px",
      dependOnPlane: true,
    },
    {
      title: <IntlMessages id="leftMenu.client.settings" />,
      url: "/settings",
      icon: "setting",
      permissionKey: "customerDashboard",
      top: "4px",
      dependOnPlane: false,
    },
  ],

  superAdmin: [
    {
      title: <IntlMessages id="leftMenu.dashboard" />,
      url: "/admin/dashboard",
      icon: "dasbhoard",
      top: "4px",
      permissionKey: "dashboard",
    },

    {
      title: "Questionnaire",
      url: "/dailyLivingActivity",
      icon: "auth-screen",
      top: "4px",
      keyTitle: "Questionnaire",
      permissionKey: "Questionnaire",
      subMenu: [
        {
          title: (
            <IntlMessages id="leftMenu.questionnaire.dailyLivingActivities" />
          ),
          url: "/dailyLivingActivities",
          icon: "",
          key: "Questionnaire",
        },
        {
          title: <IntlMessages id="leftMenu.questionnaire.healthCondition" />,
          url: "/healthCondition",
          icon: "",
          key: "Questionnaire",
        },
        {
          title: <IntlMessages id="leftMenu.questionnaire.dailyBaseline" />,
          url: "/dailyBaseLine",
          icon: "",
          key: "Questionnaire",
        },
        {
          title: <IntlMessages id="leftMenu.questionnaire.redFlags" />,
          url: "/redFlags",
          icon: "",
          key: "Questionnaire",
        },
      ],
    },
    {
      title: <IntlMessages id="leftMenu.users" />,
      url: "/users",
      icon: "feedback",
      top: "4px",
      permissionKey: "inspector",
    },
    {
      title: <IntlMessages id="leftMenu.corporateAccounts" />,
      url: "/corporateAccounts",
      icon: "wall",
      top: "4px",
      permissionKey: "corporateAccounts",
    },
    {
      title: <IntlMessages id="leftMenu.reports" />,
      url: "/reports",
      icon: "product-list",
      top: "4px",
      permissionKey: "tasks",
    },
    {
      title: <IntlMessages id="leftMenu.inventory" />,
      url: "/admin/inventory",
      icon: "feedback",
      top: "4px",
      permissionKey: "tasks",
    },
    {
      title: <IntlMessages id="leftMenu.settings" />,
      url: "/settings",
      icon: "setting",
      top: "4px",
      permissionKey: "tasks",
    },
  ],
};

export default MenuList;
